export default __webpack_public_path__ + "static/media/Secret.101f159f.gif";